
interface Testimonial {
  text: string;
  name: string;
  initials: string;
  location: string;
  rating: number;
}

export const testimonials: Testimonial[] = [];

// Company achievements and certifications from HomeAdvisor
export const achievements = [
  {
    "name": "50+ Reviews",
    "image": "https://cdn1.homeadvisor.com/images/sp-badges/50reviews.png",
    "description": "Over 50 verified customer reviews on HomeAdvisor"
  },
  {
    "name": "5 Years with HomeAdvisor",
    "image": "https://cdn1.homeadvisor.com/images/sp-badges/5year.png",
    "description": "5 years of trusted service with HomeAdvisor"
  },
  {
    "name": "Best of HomeAdvisor 2020",
    "image": "https://cdn1.homeadvisor.com/images/sp-badges/boha-2020.png",
    "description": "Best of HomeAdvisor winner for exceptional service in 2020"
  },
  {
    "name": "HomeAdvisor Elite Service",
    "image": "https://cdn1.homeadvisor.com/images/sp-badges/elite.png",
    "description": "Elite service professional with excellent customer reviews"
  },
  {
    "name": "HomeAdvisor Top Rated",
    "image": "https://cdn1.homeadvisor.com/images/sp-badges/toprated.png",
    "description": "Consistently rated among the top professionals in the area"
  },
  {
    "name": "HomeAdvisor Screened & Approved",
    "image": "https://cdn1.homeadvisor.com/images/sp-badges/soap.png",
    "description": "Background checked and verified by HomeAdvisor"
  }
];
